import { Box, Divider, IconButton, Popover, Stack, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';

const ExplanationTooltip = () => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<>
			<Tooltip title="What do the shapes mean?" placement="bottom" arrow>
				<span>
					<IconButton color="primary" size={'large'} onClick={handlePopoverOpen} ref={anchorEl}>
						<span className="material-symbols-outlined" style={{ fontSize: 24 }}>
							question_mark
						</span>
					</IconButton>
				</span>
			</Tooltip>
			<Popover
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
				elevation={2}
			>
				<Box p={'20px'}>
					<Stack spacing={'20px'} alignItems={'center'}>
						<Stack spacing={'15px'} alignItems={'center'}>
							<Typography fontWeight={500}>Household</Typography>
							<Stack spacing={'20px'} direction={'row'} alignItems={'center'}>
								<Typography fontWeight={500}>Individual</Typography>
								<svg width="91" height="90" viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg">
									<mask id="path-1-inside-1_342_8819" fill="white">
										<path d="M90.5 42.8226C90.5 65.3226 65.5566 90 45.9562 90C26.3558 90 0.5 65.3226 0.5 42.8226C0.5 20.3226 26.3558 0 45.9562 0C65.5566 0 90.5 20.3226 90.5 42.8226Z" />
									</mask>
									<path
										d="M46.2071 11.2929C45.8166 10.9024 45.1834 10.9024 44.7929 11.2929L38.4289 17.6569C38.0384 18.0474 38.0384 18.6805 38.4289 19.0711C38.8195 19.4616 39.4526 19.4616 39.8431 19.0711L45.5 13.4142L51.1569 19.0711C51.5474 19.4616 52.1805 19.4616 52.5711 19.0711C52.9616 18.6805 52.9616 18.0474 52.5711 17.6569L46.2071 11.2929ZM44.7929 78.2071C45.1834 78.5976 45.8166 78.5976 46.2071 78.2071L52.5711 71.8431C52.9616 71.4526 52.9616 70.8195 52.5711 70.4289C52.1805 70.0384 51.5474 70.0384 51.1569 70.4289L45.5 76.0858L39.8431 70.4289C39.4526 70.0384 38.8195 70.0384 38.4289 70.4289C38.0384 70.8195 38.0384 71.4526 38.4289 71.8431L44.7929 78.2071ZM11.2929 44.2929C10.9024 44.6834 10.9024 45.3166 11.2929 45.7071L17.6569 52.0711C18.0474 52.4616 18.6805 52.4616 19.0711 52.0711C19.4616 51.6805 19.4616 51.0474 19.0711 50.6569L13.4142 45L19.0711 39.3431C19.4616 38.9526 19.4616 38.3195 19.0711 37.9289C18.6805 37.5384 18.0474 37.5384 17.6569 37.9289L11.2929 44.2929ZM78.2071 45.7071C78.5976 45.3166 78.5976 44.6834 78.2071 44.2929L71.8431 37.9289C71.4526 37.5384 70.8195 37.5384 70.4289 37.9289C70.0384 38.3195 70.0384 38.9526 70.4289 39.3431L76.0858 45L70.4289 50.6569C70.0384 51.0474 70.0384 51.6805 70.4289 52.0711C70.8195 52.4616 71.4526 52.4616 71.8431 52.0711L78.2071 45.7071ZM44.5 12V77.5H46.5V12H44.5ZM12 46H77.5V44H12V46ZM88.5 42.8226C88.5 53.3808 82.6072 64.7033 74.1406 73.4585C65.6533 82.2349 55.0027 88 45.9562 88V92C56.5102 92 68.1315 85.4263 77.016 76.2391C85.9211 67.0306 92.5 54.7644 92.5 42.8226H88.5ZM45.9562 88C36.8991 88 26.0156 82.2244 17.2975 73.44C8.59736 64.6736 2.5 53.3564 2.5 42.8226H-1.5C-1.5 54.7888 5.33056 67.0603 14.4584 76.2576C23.5683 85.4369 35.413 92 45.9562 92V88ZM2.5 42.8226C2.5 32.3363 8.55094 22.1331 17.2038 14.4711C25.8622 6.80435 36.7739 2 45.9562 2V-2C35.5381 -2 23.7217 3.35695 14.5521 11.4764C5.37698 19.6008 -1.5 30.8089 -1.5 42.8226H2.5ZM45.9562 2C55.1299 2 65.8072 6.79693 74.2332 14.4539C82.6507 22.1031 88.5 32.3099 88.5 42.8226H92.5C92.5 30.8353 85.8777 19.6307 76.9233 11.4936C67.9776 3.36436 56.3829 -2 45.9562 -2V2Z"
										fill="#E5006E"
										mask="url(#path-1-inside-1_342_8819)"
									/>
								</svg>

								<Typography fontWeight={500}>Community</Typography>
							</Stack>
							<Typography fontWeight={500}>Society</Typography>
						</Stack>
						<Divider sx={{ width: '100%' }} />
						<Typography width={330}>
							The Resilience Index is the average of four aspects: Individual, Household, Community, and Society. A
							larger shape indicates greater resilience in that aspect.
						</Typography>
					</Stack>
				</Box>
			</Popover>
		</>
	);
};

export default ExplanationTooltip;
